import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { PrintRsService } from 'src/app/shared/services/rs-fiskalizacija/print-rs.service';

@Component({
  selector: 'app-rs-fiscalization',
  templateUrl: './rs-fiscalization.component.html',
  styleUrl: './rs-fiscalization.component.scss',
  standalone: false
})
export class RsFiscalizationComponent implements OnInit {
  loading = {};
  invoices = [];

  invoiceSearchForm = new UntypedFormGroup({
    fromDate: new UntypedFormControl(this.today("00:00"), Validators.required),
    toDate: new UntypedFormControl(this.today("23:59"), Validators.required),
    // amountFrom: new UntypedFormControl(null),
    // amountTo: new UntypedFormControl(null),
    // invoiceTypes: new UntypedFormControl(null),
    // transactionTypes: new UntypedFormControl(["Sale", "Refund"]),
    // paymentTypes: new UntypedFormControl(["Cash", "WireTransfer"]),
  });

  constructor(
    private printRSService: PrintRsService,
    private datePipe: DatePipe,
    private toastr: ToastrService,
    private translate: TranslateService
  ) {

  }

  ngOnInit(): void {
    this.searchInvoices();
  }

  searchInvoices() {
    this.invoices = [];
    this.loading['invoices'] = true;
    this.printRSService.searchInvoices(this.invoiceSearchForm.value).subscribe(resp => {
      this.loading['invoices'] = false;
    }, error => {
      this.loading['invoices'] = false;
      var list = error.error.text.split("\n")
      list.forEach(element => {
        var item = element.split(",")
        var itemAdd = {
          brojRacuna: item[0],
          vrsta: item[1],
          tip: item[2],
          datum: item[3],
          iznos: +item[4],
        }
        this.invoices.push(itemAdd);
      });
    })
  }

  dateChanged() {
    this.searchInvoices();
  }

  today(hours) {
    let date = new Date();
    let pipedDate = this.datePipe.transform(date, 'yyyy-MM-ddT' + hours);
    return pipedDate;
  }

  getFiskalniPromet() {
    var sum = 0;
    this.invoices.forEach(element => {
      if (element.vrsta == "Copy") { }
      else if (element.tip == "Sale") { sum += +element.iznos }
    })
    return sum
  }

  getReklamiraniPromet() {
    var sum = 0;
    this.invoices.forEach(element => {
      if (element.vrsta == "Copy") { }
      else if (element.tip == "Refund") { sum += element.iznos }
    })
    return sum
  }

  getTotalPromet() {
    var fiskalni = 0;
    var reklamirani = 0;
    this.invoices.forEach(element => {
      if (element.vrsta == "Copy") { }
      else if (element.tip == "Sale") { fiskalni += +element.iznos }
      else if (element.tip == "Refund") { reklamirani += +element.iznos }
    })
    var sum = (fiskalni - reklamirani);
    return sum;
  }

  provjeriStatus() {
    this.loading['attention'] = true;
    this.printRSService.getAttention().subscribe(resp => {
      this.toastr.success(this.translate.instant("MESSAGE.Uređaj je dostupan"));
      this.loading['attention'] = false;
    })
  }
}
